import * as c from "react";
function x(s = {}) {
  const {
    strict: a = !0,
    errorMessage: i = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name: u
  } = s, t = c.createContext(void 0);
  t.displayName = u;
  function r() {
    var n;
    const o = c.useContext(t);
    if (!o && a) {
      const e = new Error(i);
      throw e.name = "ContextError", (n = Error.captureStackTrace) == null || n.call(Error, e, r), e;
    }
    return o;
  }
  return [
    t.Provider,
    r,
    t
  ];
}
export {
  x as createContext
};
